import Crocodoc from 'crocodoc'
import DocumentViewPaginator from './DocumentViewPaginator'
import Spinner from './Spinner'
import $ from 'jquery'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class DocumentView extends PureComponent {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    isFetching: PropTypes.bool.isRequired,
    onNextPageClick: PropTypes.func.isRequired,
    onPageFocus: PropTypes.func,
    onPrevPageClick: PropTypes.func.isRequired,
    onReady: PropTypes.func,
    sessionId: PropTypes.string,
    totalPages: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)

    this.onPageLoad = this.onPageLoad.bind(this)
    this.onReady = this.onReady.bind(this)

    this.state = {
      viewerReady: false
    }
  }

  componentDidMount() {
    const { sessionId } = this.props

    if (sessionId) {
      this.setupViewer(sessionId)
    }
  }

  componentWillReceiveProps({ currentPage }) {
    if (this.props.currentPage !== currentPage && !this.scrolling) {
      this.viewer.scrollTo(currentPage)
    }
  }

  componentDidUpdate() {
    const { sessionId } = this.props

    if (sessionId && !this.viewer) {
      this.setupViewer(sessionId)
    }
  }

  componentWillUnmount() {
    this.viewer.off('ready')
    this.viewer.off('pagefocus')
    this.viewer.off('pageload')
    this.viewer.off('scrollstart')
    this.viewer.off('scrollend')
    this.viewer.destroy()
  }

  onPageLoad({ data: { page } }) {
    const $page = $(this.el).find(`.crocodoc-page:nth-child(${page})`)

    $page
      .find('span.tx span:not(.highlightLime)')
      .contents()
      .unwrap()
    $page.find('span.tx:not(.normalized)').each((index, elem) => {
      elem.normalize()
      $(elem).addClass('normalized')
    })
  }

  onReady(event) {
    const page = this.el.getElementsByClassName('crocodoc-page')[0]

    this.el.style.height = page.style.height
    this.setState({ viewerReady: true })
    this.props.onReady(event)
  }

  setupViewer(sessionId) {
    const { onPageFocus } = this.props

    this.viewer = Crocodoc.createViewer(this.el, {
      url: `https://view-api.box.com/1/sessions/${sessionId}/assets`,
      zoom: Crocodoc.ZOOM_FIT_WIDTH
    })

    this.viewer.load()
    this.viewer.on('ready', this.onReady)
    this.viewer.on('pagefocus', onPageFocus)
    this.viewer.on('pageload', this.onPageLoad)
    this.viewer.on('scrollstart', () => (this.scrolling = true))
    this.viewer.on('scrollend', () => (this.scrolling = false))
  }

  render() {
    const {
      currentPage,
      isFetching,
      onNextPageClick,
      onPrevPageClick,
      totalPages
    } = this.props
    const { viewerReady } = this.state

    return (
      <div className="box-viewer box-draw">
        <Spinner spinning={isFetching || !viewerReady} />
        <DocumentViewPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          onNextPageClick={onNextPageClick}
          onPrevPageClick={onPrevPageClick}
        />
        <div
          ref={el => {
            this.el = el
          }}
          className="box-viewer-container"
          style={{ minHeight: 600 }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DocumentView.js